import Client from './ApiClient'

const resource = 'refund-requests'

const getAll = () => {
  return Client.get(`${resource}`)
}

const update = (id, data) => {
  return Client.put(`${resource}/${id}`, data)
}

export default { getAll, update }
